var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircleGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49967 17.4173C13.8538 17.4173 17.4163 13.8548 17.4163 9.50065C17.4163 5.14648 13.8538 1.58398 9.49967 1.58398C5.14551 1.58398 1.58301 5.14648 1.58301 9.50065C1.58301 13.8548 5.14551 17.4173 9.49967 17.4173Z",
    stroke: "#13A007",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13477 9.50018L8.37518 11.7406L12.8639 7.25977",
    stroke: "#13A007",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircleGreen);
export default __webpack_public_path__ + "static/media/tick-circle-green.d91395d5679f04c9904dd155cbc3ea38.svg";
export { ForwardRef as ReactComponent };